import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  className?: string;
  number: number;
  title: string;
};
export const BookingStepTitle = ({ className, number, title }: Props) => (
  <h3
    className={classnames('font-sans text-20 font-bold leading-tight', className)}
    data-testid={`BookingCriteriaStep-title--${number}`}
  >
    <span className="text-28 lg:text-22">{number}.</span> {title}
  </h3>
);
